// the Uniswap Default token list lives here
//export const DEFAULT_TOKEN_LIST_URL = 'https://units.swop.fi/default-token-list.json'
export const DEFAULT_TOKEN_LIST_URL =
  'https://raw.githubusercontent.com/swopfi/static-content/refs/heads/main/unit0/default-token-list.json'

export const DEFAULT_LIST_OF_LISTS: string[] = [DEFAULT_TOKEN_LIST_URL]
